// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after {
  box-sizing: border-box;
}

.template-wrapper.teacher-overview-layout {
  flex: 1 1 0;
  min-width: 0;
  width: auto;
}

.dYY6MP3uJ4XDIGLhFg1_ {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-bottom: 12px;
}
@media (max-width: 768px) {
  .dYY6MP3uJ4XDIGLhFg1_ {
    align-items: flex-start;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/global/Colors.scss","webpack://./src/styles/TeacherOverviewHome.module.scss"],"names":[],"mappings":"AAAA;;;EAGI,sBAAA;ACCJ;;AAFA;EACI,WAAA;EACA,YAAA;EACA,WAAA;AAKJ;;AAFA;EACI,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,mBAAA;AAKJ;AAHI;EANJ;IAOQ,uBAAA;EAMN;AACF","sourcesContent":["*,\n*::before,\n*::after {\n    box-sizing: border-box;\n}\n// EPR colors\n// $dashboard-blue: #007bff; this color does not pass Accessibility. Updated version below.\n$dashboard-blue: #0d6efd;\n$dk-blue-toolbar: #19608f;\n$dk-blue: #0A4064;\n$lt-blue: #7DB7CC;\n$pale-blue: #c0def0;\n$information: #00AEEF;\n$information-hover: #02BFFF;\n$DCSD-logo-green: #84ae30;\n$text: #414042;\n$white: #EDEDED;\n$shadow: #525151;\n$red: #CB321A;\n$red-hover: #E2381D;\n$green: #C7CC68;\n\n$highlight: #FDF9D0;\n$important: #FEBF31;\n$lt-important: #FED883;\n$lt-highlight: #FAFAD2;\n$grey0: #EDF0F1;\n$grey1: #D1D3D4;\n$grey2: #A7A9AC;\n$grey3: #808080;\n$grey3a: #707070;\n$grey4: #636161;\n$grey4a: #444343;\n$pearl-blue: #0669B3;\n$pearl-blue-hover: #1786DB;\n$lt-pearl-blue: #63AEDE;\n$lt-pearl-blue-hover: #4589B3;\n\n$timeline-arrow-1: #718355;\n$timeline-arrow-2: #87986a;\n$timeline-arrow-3: #97a97c;\n$timeline-arrow-4: #b5c99a;\n$timeline-arrow-5: #cfe1b9;\n\n$permission-blue: #ADD8E6;\n$permission-green:#90EE90;\n$permission-orange: #FFA07A;\n","@import \"global/Colors\";\n\n:global(.template-wrapper.teacher-overview-layout) {\n    flex: 1 1 0;\n    min-width: 0;\n    width: auto;\n}\n\n.titleSection {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    margin-bottom: 12px;\n\n    @media (max-width: 768px) {\n        align-items: flex-start;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export var titleSection = `dYY6MP3uJ4XDIGLhFg1_`;
export default ___CSS_LOADER_EXPORT___;
